<template>
  <div>
    <b-modal
      size="lg"
      id="modal-1"
      title="اطلاعات تراکنش"
      ok-only
      ok-title="بستن"
    >
      <div class="row" v-if="transaction !== null">
        <!-- <div
          class="col-md-6 text-danger"
          v-if="transaction != null && transaction.refund != 0"
        >
          <b-form-group
            :label="
              this.api == undefined
                ? 'مبلغ بازگشت وجه (ریال):'
                : 'مبلغ بازگشت وجه (دلار)'
            "
          >
            <div class="form-control text-danger">
              {{ transaction.refund_cost.toLocaleString() }} ریال
            </div>
          </b-form-group>
        </div> -->
        <div class="col-md-6 text-danger">
          <b-form-group label="کد رهگیری:">
            <div class="form-control">
              {{ transaction.sale_refrence_id }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="وضیعت تراکنش:">
            <div class="form-control" v-if="transaction.is_verify">
              پرداخت شده
            </div>
            <div class="form-control" v-if="!transaction.is_verify">
              پرداخت نشده
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="شماره کارت:">
            <div class="form-control" dir="ltr">
              {{ transaction.card_holder_pan }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="کد تراکنش:">
            <div class="form-control">
              {{ transaction.id }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="مبلغ تراکنش (ریال):">
            <div class="form-control">
              {{ Number(transaction.cost).toLocaleString() }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="کارمزد (ریال):">
            <div class="form-control">
              {{ Number(transaction.shepa_karmozd).toLocaleString() }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="مبلغ با احتساب کارمزد (ریال):">
            <div class="form-control">
              {{
                Number(
                  transaction.cost - transaction.shepa_karmozd
                ).toLocaleString()
              }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="آدرس درخواست دهنده:">
            <b-input-group>
              <template #append>
                <b-input-group-text
                  ><strong class="text-danger"
                    ><b-img
                      v-if="transaction.ip"
                      class="float-left pt-0"
                      :src="'media/svg/flags/Question-circle.svg'"
                      width="30"
                      height="20"
                    ></b-img></strong
                ></b-input-group-text>
              </template>
              <div class="form-control">
                {{ transaction.ip }}
              </div>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="شماره فاکتور:">
            <div class="form-control" dir="ltr">
              {{ transaction.order_id }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="نام پرداخت کننده:">
            <div class="form-control">
              {{ transaction.name }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="شماره همراه پرداخت کننده:">
            <div class="form-control">
              {{ transaction.mobile }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="کد ملی پرداخت کننده:">
            <div class="form-control">
              {{ transaction.national_id }}
            </div>
          </b-form-group>
        </div>
      </div>
      <div>
        <b-form-group label="توضیحات" v-if="transaction">
          <div class="form-control">
            {{ transaction.description }}
          </div>
        </b-form-group>
      </div>
    </b-modal>

    <b-modal
      id="modal-refund"
      title="بازگشت وجه تراکنش"
      hide-header-close
      cancel-title=""
    >
      <b-alert :show="showError" variant="danger">
        {{ errorText }}
        <p v-for="item in errorText" :key="item.id">
          <span v-if="item == 'موجودی شما کافی نمی باشد'"
            >.برای افزایش شارژ
            <a
              @click="returnToRefund"
              style="color: blue; text-decoration: underline; cursor: pointer"
              >اینجا</a
            >
            کلیک کنید.</span
          >
        </p>
        <p></p>
      </b-alert>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="مبلغ تراکنش (ریال):">
            <div class="form-control">
              {{
                transaction != null
                  ? Number(transaction.cost).toLocaleString()
                  : 0
              }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="شماره تراکنش:">
            <div class="form-control">
              {{ transaction != null ? transaction.id : 0 }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="کد رهگیری:">
            <div class="form-control">
              {{ transaction != null ? transaction.sale_refrence_id : 0 }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="مبلغ مورد نظر برای بازگشت وجه (ریال):">
            <NumberSeprator v-model="refundamount"></NumberSeprator>
          </b-form-group>
        </div>
      </div>
      <template #modal-footer="{}">
        <b-button variant="outline-secondary" @click="close"> انصراف </b-button>
        <b-button
          :class="'ml-3 ' + (show ? 'spinner spinner-light spinner-right' : '')"
          variant="success"
          :disabled="show"
          @click="RefundTransaction"
        >
          ثبت و ذخیره
        </b-button>
      </template>
    </b-modal>

    <TableShowData
      :url="settlementstable.url"
      :fields="settlementstable.fields"
      :btns="settlementstable.btns"
      :params="settlementstable.params"
      :excelroute="'excelroute'"
    >
    </TableShowData>
  </div>
</template>
<style >
.ltr-dir {
  direction: ltr;
}
</style>
<script>
import NumberSeprator from "../../components/numberSeprator";
import TableShowData from "../../components/table.vue";
import httpHelper from "../../helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import * as moment from "jalali-moment";
import _ from "lodash";

export default {
  name: "transactionList",
  props: ["api"],
  data() {
    return {
      show: false,
      amount: 0,
      refundamount: 0,
      totalCredit: 0,
      transaction: null,
      modalRefund: false,
      showError: false,
      errorText: [],
      settlementstable: {
        url:
          "~reports/api/user-transactions" +
          (this.api ? "?mdid12_money_type=1722" : ""),
        params: [
          {
            label: "از تاریخ:",
            field: "date_from",
            // value: moment().format("jYYYY/jM/jD"),
            type: "date-picker",
          },
          {
            label: "تا تاریخ:",
            field: "date_to",
            // value: moment().format("jYYYY/jM/jD"),
            type: "date-picker",
          },
          {
            label: "کد رهگیری:",
            field: "sale_refrence_id",
            type: "text",
          },
          {
            label: "چهار رقم آخر کارت:",
            field: "card_holder_pan",
            type: "text",
          },
          {
            label: "مبلغ:",
            field: "cost",
            type: "number",
          },
          {
            label: "توضیحات:",
            field: "description",
            type: "text",
          },
          {
            label: "موبایل:",
            field: "mobile",
            type: "text",
          },
          {
            label: "پست الکترونیکی:",
            field: "email",
            type: "text",
          },
          {
            label: "نوع تراکنش:",
            field: "transaction_type",
            type: "select",
            value: null,
            options: [
              { value: null, text: "همه تراکنش ها" },
              { value: "deposit", text: "فقط واریز" },
              { value: "withdraw", text: "فقط برداشت" },
            ],
          },
          {
            label: "وضعیت:",
            field: "is_verify",
            type: "select",
            value: null,
            options: [
              { value: null, text: "انتخاب نشده" },
              { value: "1", text: "تایید شده" },
              { value: "0", text: "تایید نشده" },
            ],
          },
          {
            label: "درگاه:",
            field: "acceptorcode",
            type: "select",
            options: [],
          },
        ],
        fields: [
          {
            key: "website_name",
            label: "وبسایت",
          },
          {
            key: "cost",
            label: "مبلغ تراکنش",
            formatter(value, key, item) {
              if (item.reversed) return value * -1;
              return Number(value).toLocaleString();
            },
            tdClass(value, key, item) {
              return value > 0 ? "text-success" : "text-danger";
            },
          },
          {
            key: "shepa_karmozd",
            label: "کامزد",
            formatter(value, key, item) {
              return Number(
                value == 0
                  ? item.shaparak_karmozd
                  : value - item.shaparak_karmozd
              ).toLocaleString();
            },
            tdClass(value, key, item) {
              return value - item.shaparak_karmozd > 0
                ? "text-danger"
                : "text-success";
            },
          },
          {
            key: "shaparak_karmozd",
            label: "کارمزد شبکه بانکی",
            formatter(value, key, item) {
              return Number(value ? value : 0).toLocaleString();
            },
            tdClass(value, key, item) {
              return "text-danger";
            },
          },
          {
            key: "amount",
            label: "مبلغ پس از کسر کارمزد",
            formatter(value, key, item) {
              if (item.reversed) return 0;
              return Number(item.cost - item.shepa_karmozd).toLocaleString();
            },
            tdClass(value, key, item) {
              var val = item.cost;
              return val > 0 ? "text-success" : "text-danger";
            },
          },
          {
            key: "is_verify",
            label: "وضعیت",
            formatter(value, key, item) {
              return value == false
                ? "تایید نشده"
                : item.reversed
                ? "برگشت خورده"
                : "تایید شده";
            },
            tdClass(value, key, item) {
              return value == false
                ? "text-danger"
                : item.reversed
                ? "text-warning"
                : "text-success";
            },
          },
          {
            key: "created_at",
            label: "تاریخ تراکنش",
            formatter(value, key, item) {
              return (
                moment(value , "YYYY/MM/DDThh:mm:ss").format('jYYYY/jMM/jDD H:m:s')
              );
            },
            tdClass:"ltr-dir"
          },
          // {
          //   key: "factor_id",
          //   label: "شماره فاکتور",
          // },
          {
            key: "sale_refrence_id",
            label: "کد رهگیری پرداخت",
            formatter(value, key, item) {
              if (item.refunds != null && item.refunds.length > 0) {
                var amount = _.sum(item.refunds, function () {
                  return o.cost;
                });
                var respo = value + " (" + amount.amount + " ریفاند شده)";
                return respo;
              } else return value;
            },
          },

          // {
          //   key: "totalsum",
          //   label: "موجودی",
          //   formatter(value, key, item) {
          //     return Number(value).toLocaleString();
          //   },
          //   tdClass(value, key, item) {
          //     var val = item.amount;
          //     return val > 0 ? "text-success" : "text-danger";
          //   },
          // },

          {
            key: "btns",
            label: "عملیات",
          },
        ],
        btns:
          this.api == undefined
            ? [
                {
                  icon: "eye-fill",
                  handler: (t) => {
                    this.transaction = t;
                    this.$bvModal.show("modal-1");
                  },
                  title: "توضیحات",
                },
                {
                  icon: "reply-fill",
                  handler: (t) => {
                    this.transaction = t;
                    this.$bvModal.show("modal-refund");
                    // this.modalRefund=true;
                  },
                  title: "ریفاند",
                },
              ]
            : [
                {
                  icon: "eye-fill",
                  handler: (t) => {
                    this.transaction = t;
                    this.$bvModal.show("modal-1");
                  },
                  title: "توضیحات",
                },
              ],
      },
    };
  },
  components: {
    TableShowData,
    NumberSeprator,
  },
  methods: {
    close() {
      this.refundamount = 0;
      this.errorText = [];
      this.showError = false;
      this.$bvModal.hide("modal-refund");
    },
    returnToRefund() {
      this.$router.push("/refunds");
    },
    number(value) {
      return Number(value);
    },
    RefundTransaction() {
      this.show = true;
      httpHelper
        .postData("~transaction/api/v1/refund-transaction", {
          transaction_id: this.transaction.id,
          amount: this.refundamount,
          api: this.transaction.pin,
        })
        .then((res) => {
          this.refundamount = 0;
          this.show = !this.show;
          if (res.success) {
            this.settlementstable.url =
              "~transaction/transaction" +
              (this.api ? "?mdid12_money_type=1722" : "") +
              "&t=" +
              new Date().getTime();
            this.amount = res.result.amount;
            this.$bvModal.hide("modal-refund");
            this.$makeToast(
              "success",
              "پرداخت موفق",
              `درخواست برگشت وجه به مبلغ ${this.amount} ریال با موفقیت ثبت گردید.`,
              5000
            );
          } else {
            this.showError = true;
            this.errorText = res.errors;
          }
        });
    },
    getKarmozd() {
      return this.transaction.cost - this.transaction.amount;
      // if (this.transaction.doc) {
      //   var ddetails = this.transaction.doc.doc_details;
      //   for (let i = 0; i < ddetails.length; i++) {
      //     const element = ddetails[i];
      //     if (element.amount < 0) {
      //       return element.amount * -1;
      //     }
      //   }
      // }
      // return 0;
    },
    getData() {
      let api;
      api = this.api ? 1722 : 483;
      httpHelper.getData(`paymentgateways?money_type=${api}`).then((res) => {
        this.settlementstable.params[10].options = res.result
          // .filter((t) => {
          //   return t.mdid12_money_type == 483 || t.mdid12_money_type == 484;
          // })
          .map((t) => {
            return {
              text: t.website_name + " (" + t.website + ")",
              value: t.id,
            };
          });
      });
    },
    getRefundable() {
      httpHelper.getData("getrefundprice").then((res) => {
        this.totalCredit = Number(res.result).toLocaleString();
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست تراکنش های ریالی",
      },
    ]);
    this.getData();
    this.getRefundable();
  },
};
</script>
<style scoped>
</style>